import { words } from "./Dictionery";
export const ReVAMPWords = {
  ...words,
  "Assign Maintenance": { en: "Assign Repair", es: "Asignar reparación", fr: "Assigner la réparation" },
  "Maintenance Type": { en: "Repair Type", es: "Tipo de reparación", fr: "Type de réparation" },
  Maintenance: { en: "Repair", es: "Reparación", fr: "Réparation" },
  MAINTENANCE: { en: "REPAIR", es: "REPARACIÓN", fr: "RÉPARATION" },
  "Maintenance Information": { en: "Repair Information", es: "Información de reparación", fr: "Informations sur la réparation" },
  "Maintenance Types": { en: "Repair Types", es: "Tipos de reparación", fr: "Types de réparation" },

  "MAINTENANCE HISTORY": { en: "REPAIR HISTORY", es: "Historial de Reparaciones", fr: "Historique des réparations" },
  "Maintenance History": { en: "Repair History", es: "Historial de Reparación", fr: "Historique de Réparation" },
  "Locomotive Maintenance History": {
    en: "Locomotive Repair History",
    es: "Historial de Reparación de Locomotoras",
    fr: "Historique de Réparation de Locomotive",
  },
  "Locomotive Maintenance Record": {
    en: "Locomotive Repair Record",
    es: "Registro de Reparación de Locomotoras",
    fr: "Registre de Réparation de Locomotive",
  },
  "ASSET MAINTENANCE HISTORY": {
    en: "ASSET REPAIR HISTORY",
    es: "HISTORIAL DE REPARACIONES DEL ACTIVO",
    fr: "HISTORIQUE DES RÉPARATIONS DE L'ACTIF",
  },

  "Work Order": {
    en: "Repair",
    es: "Reparar",
    fr: "Réparer",
  },
  "work orders": {
    en: "repairs",
    es: "Reparar",
    fr: "Réparer",
  },
  "Work Order List": {
    en: "Repair List",
    es: "Lista de Reparaciones",
    fr: "Liste des Réparations",
  },
  "Add Work Order": {
    en: "Add Repair",
    es: "Agregar Reparación",
    fr: "Ajouter une Réparation",
  },
  "Add New Work Order": {
    en: "Add New Repair",
    es: "Agregar Nueva Reparación",
    fr: "Ajouter une Nouvelle Réparation",
  },
  "Edit Work Order": {
    en: "Edit Repair",
    es: "Editar Reparación",
    fr: "Modifier la Réparation",
  },
  "Work Order Detail": {
    en: "Repair Details",
    es: "Detalle de Reparación",
    fr: "Détail de la Réparation",
  },
  "Work Order Reports": {
    en: "Repair Reports",
    es: "Informes de Reparación",
    fr: "Rapports de Réparation",
  },
  "Work Order Report": {
    en: "Repair Report",
    es: "Informe de Reparación",
    fr: "Rapport de Réparation",
  },
  "Work Order Summary Report": {
    en: "Repair Summary Report",
    es: "Informe Resumen de Reparación",
    fr: "Rapport Résumé de Réparation",
  },
  "Work Order Information": {
    en: "Repair Information",
    es: "Información de Reparación",
    fr: "Informations sur la Réparation",
  },
  "Work Order Tab": {
    en: "Repair Info",
    es: "Información de Reparación",
    fr: "Informations sur la Réparation",
  },
};

// lampWords["Maintenance Type"] = { en: "Repair Type", es: "Tipo de reparación", fr: "Type de réparation" };
// lampWords["Assign Maintenance"] = { en: "Assign Repair", es: "Asignar reparación", fr: "Assigner la réparation" };
// lampWords["Maintenance"] = { en: "Repair", es: "Reparación", fr: "Réparation" };



// WEBPACK FOOTER //
// ./src/Language/ReVAMPDictionary.js